'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.changeQuery = changeQuery;
exports.getSearchResult = getSearchResult;
exports.changeFlag = changeFlag;
exports.openFilter = openFilter;
exports.closeFilter = closeFilter;
exports.changeSortType = changeSortType;
exports.getShopSearch = getShopSearch;
exports.lazyLoad = lazyLoad;
exports.changeFilter = changeFilter;

var _support = require('helpers/support');

var _ApiClientv = require('helpers/ApiClientv2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CHANGE_QUERY = 'lookme/CHANGE_QUERY';
var LOAD = 'lookme/filter/LOAD';
var LOAD_SUCCESS = 'lookme/filter/LOAD_SUCCESS';
var LOAD_FAIL = 'lookme/filter/LOAD_FAIL';
var CHANGE_SORT_TYPE = 'lookme/filter/CHANGE_SORT_TYPE';
var CHANGE_FLAG = 'lookme/filter/CHANGE_FLAG';
var OPEN_FILTER = 'lookme/filter/OPEN_FILTER';
var CLOSE_FILTER = 'lookme/filter/CLOSE_FILTER';
var CHANGE_FILTER_ACTIVE = 'lookme/filter/CHANGE_FILTER_ACTIVE';
var LAZY_LOAD_SUCCESS = 'lookme/filter/LAZY_LOAD_SUCCESS';


var initialState = {
  query: '',
  loaded: false,
  loading: false,
  sort: 'prominent',
  filterFullScreen: false,
  flagSearch: false,
  filterActive: {}
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CHANGE_QUERY:
      return (0, _extends3.default)({}, state, {
        query: action.query
      });
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: action.result && action.result.data || [],
        total: action.result && action.result.total || 0,
        pageSize: action.result && action.result.pageSize || 12,
        loading: false,
        loaded: true
      });
    case LAZY_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: state.data && action.result && [].concat((0, _toConsumableArray3.default)(state.data), (0, _toConsumableArray3.default)(action.result.data)) || action.result && action.result.data || [],
        total: action.result && action.result.total || 0,
        pageSize: action.result && action.result.pageSize || 12,
        loading: false,
        loaded: true
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        errLoading: action.err,
        loading: false,
        loaded: true
      });
    case CHANGE_SORT_TYPE:
      return (0, _extends3.default)({}, state, {
        sort: action.payload
      });
    case CHANGE_FLAG:
      return (0, _extends3.default)({}, state, {
        flagSearch: action.payload
      });
    case OPEN_FILTER:
      return (0, _extends3.default)({}, state, {
        filterFullScreen: action.payload
      });
    case CLOSE_FILTER:
      return (0, _extends3.default)({}, state, {
        filterFullScreen: action.payload
      });
    case CHANGE_FILTER_ACTIVE:
      return (0, _extends3.default)({}, state, {
        filterActive: action.filterActive
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.filter && globalState.filter.loaded;
}

function changeQuery(query) {
  return {
    type: CHANGE_QUERY,
    query: query
  };
}

function joinQuery(query) {
  var array = [];
  for (var key in query) {
    if (query.hasOwnProperty(key)) {
      var value = query[key];
      if (key === 'text_search') {
        value = _support.Helper.convertTextSearch(value);
      }
      array.push(key + '=' + value);
    }
  }
  return array.join('&');
}
function getSearchResult(query) {
  console.log('@getSearchResult query', query);
  var urlParam = joinQuery(query);
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise() {
      return _ApiClientv.elasticSearch.get('/shop/search?' + urlParam);
    }
  };
}
function changeFlag(value) {
  return {
    type: CHANGE_FLAG,
    payload: value
  };
}
function openFilter() {
  return {
    type: OPEN_FILTER,
    payload: true
  };
}
function closeFilter() {
  return {
    type: CLOSE_FILTER,
    payload: false
  };
}
function changeSortType(type) {
  return {
    type: CHANGE_SORT_TYPE,
    payload: type
  };
}

function getShopSearch(filterActive) {
  var urlParam = (0, _support.parseParams)(filterActive);
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise() {
      return _ApiClientv.elasticSearch.get('/shop/search?' + urlParam);
    }
  };
}

function lazyLoad(filterActive) {
  var urlParam = (0, _support.parseParams)(filterActive);
  return {
    types: [LOAD, LAZY_LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise() {
      return _ApiClientv.elasticSearch.get('/shop/search?' + urlParam);
    }
  };
}

function changeFilter(filterActive) {
  return {
    type: CHANGE_FILTER_ACTIVE,
    filterActive: filterActive
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/filter.js
// module id = 73
// module chunks = 0